import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Limites para aquisição das imagens</Title>

                    <section className="mt-2 p-3">

                        <p>
                        Os cortes devem ser programados seguindo a orientação da inferior para a superior, deixar
como margem de segurança 4cm acima do ápice pulmonar e 4cm abaixo do seio costofrênico
conforme ilustração abaixo.
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}